import * as React from 'react';
import { useState } from 'react';
import { GuestCard } from '../../../../../api/TourSignup';
import { formatPhoneNumber } from '../../../../../utilities/Utils';
import ProspectUpdateEmailPopup from '../confirmation/ProspectUpdateEmailPopup';

interface Props {
    guestCard: GuestCard;
}

const ProspectProfileDisplay = (props: Props) => {
    const [emailDisplay, setEmailDisplay] = useState(props.guestCard.profile.email);

    return (
        <div>
            {props.guestCard.profile.firstName} {props.guestCard.profile.lastName}
            <div>{formatPhoneNumber(props.guestCard.profile.phone)}</div>
            <div className="field-with-edit-button">
                {emailDisplay}
                <ProspectUpdateEmailPopup
                    guestCard={props.guestCard}
                    updateEmailDisplay={setEmailDisplay}
                />
            </div>
        </div>
    );
};

export default ProspectProfileDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/display/ProspectProfileDisplay.tsx